function Test() {
  return <div className="Test">Test route</div>;
}

export default Test;
